import { useTranslation } from 'react-i18next';
import {
  formatHumanDate,
  formatCountdown,
  formatFomo,
} from '../../utils/gameFormatters';

const HeroSection = ({ game, onShare, toast }) => {
  const { t, i18n } = useTranslation();
  const headline = formatHumanDate(game.startDate, i18n.language, t);
  const countdown = formatCountdown(game.startDate, t);
  const fomo = formatFomo(game, t);

  return (
    <>
      <header className="gp-topbar">
        <div className="gp-topbar__brand">
          <img src="/logo192.png" alt="Tenku" />
          <span>Tenku</span>
        </div>
        <button
          className="gp-topbar__share"
          onClick={onShare}
          aria-label={t('open.preview.share.button')}
        >
          ↗
        </button>
      </header>

      <div className="gp-titleblock">
        <div className="gp-titleblock__sport">{game.sportType.name}</div>
        {countdown && (
          <div className="gp-titleblock__countdown">{countdown}</div>
        )}
        <h1 className="gp-titleblock__title">{headline}</h1>
        <p className="gp-titleblock__subtitle">
          {t('open.preview.hero.subtitle', { venue: game.venue.name })}
        </p>
        <span className={`gp-titleblock__fomo gp-titleblock__fomo--${fomo.tone}`}>
          {fomo.label}
        </span>
      </div>

      {toast && <div className="gp-cta__share-toast">{toast}</div>}
    </>
  );
};

export default HeroSection;
